import { useState } from "react";
import { motion, useScroll, useSpring, useMotionValueEvent, AnimatePresence } from "framer-motion";
import { ArrowUp } from "lucide-react";

export const ScrollProgress = ({ onTop }) => {
  const { scrollYProgress, scrollY } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 30, mass: 0.3 });
  const [show, setShow] = useState(false);
  useMotionValueEvent(scrollY, "change", (v) => setShow(v > 640));

  return (
    <>
      <motion.div
        style={{ scaleX }}
        className="fixed top-0 inset-x-0 z-[70] h-[3px] origin-left bg-gradient-to-r from-amber-400 via-amber-500 to-blue-500"
        data-testid="scroll-progress-bar"
      />
      <AnimatePresence>
        {show && (
          <motion.button
            initial={{ opacity: 0, y: 24, scale: 0.8 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 24, scale: 0.8 }}
            whileHover={{ y: -4 }}
            whileTap={{ scale: 0.9 }}
            onClick={onTop}
            aria-label="Back to top"
            data-testid="back-to-top-button"
            className="fixed bottom-6 right-6 z-[65] flex h-12 w-12 items-center justify-center rounded-full bg-[#0B1528] text-white shadow-[0_16px_40px_-12px_rgba(11,21,40,0.6)] hover:bg-amber-500 hover:text-[#0B1528] transition-colors duration-300"
          >
            <ArrowUp className="h-5 w-5" />
          </motion.button>
        )}
      </AnimatePresence>
    </>
  );
};
